import { RASHI_CHART_ROWS } from './jyotishaRashiChart';
import { RASHI_LATIN_TITLE } from './jyotishaLagnaWiseAnalysis';

const TOPIC_PREFIX = 'lagna-baseline';

function topicIdForIndex(lagnaIndex) {
  return `${TOPIC_PREFIX}-${RASHI_LATIN_TITLE[lagnaIndex].toLowerCase()}`;
}

function lagnaMeta(lagnaIndex) {
  return {
    lagnaIndex,
    topicId: topicIdForIndex(lagnaIndex),
    lagnaHi: `${RASHI_CHART_ROWS[lagnaIndex].rashi} लग्न`,
    lagnaEn: `${RASHI_LATIN_TITLE[lagnaIndex]} Lagna`,
  };
}

export const LAGNA_BASELINE_PAGES = [
  {
    ...lagnaMeta(0),
    accent: 'rose',
    hookHi: '',
    hookEn: '',
    lagneshFocusHi: 'लग्नेश मंगल 1st और 8th का स्वामी होकर native को survival drive, sharpness और comeback power देता है.',
    lagneshFocusEn: 'Mars ruling the 1st and 8th gives grit, force, and a knack for handling crisis.',
    yogakarakaHi: 'इस लग्न में एकल, बिल्कुल साफ yogakaraka नहीं बनता.',
    yogakarakaEn: 'No single planet is a clean yogakaraka here - not by ownership alone.',
    specialNotes: [
      {
        titleHi: 'गुरु का 12th ownership',
        titleEn: 'Jupiter also owns the 12th',
        bodyHi: 'गुरु 9th के साथ 12th भी own करता है, इसलिए pure fortune के साथ dharma, retreat, pilgrimage, foreign links या expense themes भी जुड़ सकते हैं.',
        bodyEn: 'Jupiter carries both fortune and 12th-house themes here, so blessings often come with sacrifice, pilgrimage, retreat, or foreign distance.',
      },
      {
        titleHi: 'शुक्र strong लेकिन risky',
        titleEn: 'Venus can charm but also complicate',
        bodyHi: 'शुक्र 2nd और 7th own करके relationship, attraction और maraka themes को एक साथ activate करता है.',
        bodyEn: 'Venus rules both relationship and maraka houses, so sweetness and pressure can arrive through the same channel.',
      },
    ],
  },
  {
    ...lagnaMeta(1),
    accent: 'emerald',
    hookHi: 'वृषभ लग्न का base chart stability, value-building और steady rise का chart है.',
    hookEn: 'Vrishabha lagna builds slowly. It prefers durability and measures life in value, security, and what lasts.',
    lagneshFocusHi: 'लग्नेश शुक्र 1st और 6th का स्वामी होकर charm के साथ service, debt, health-discipline और daily grind भी जोड़ता है.',
    lagneshFocusEn: 'Venus as lord of the 1st and 6th mixes grace with duty, routines, health management, and practical friction.',
    yogakarakaHi: 'शनि 9th और 10th का स्वामी होकर इस लग्न का clear yogakaraka बनता है.',
    yogakarakaEn: 'Saturn is the clear yogakaraka here because it owns both the 9th and the 10th.',
    specialNotes: [
      {
        titleHi: 'बुध helpful है',
        titleEn: 'Mercury is a major helper',
        bodyHi: '2nd और 5th ownership के कारण बुध learning, speech, finance और intelligent gains को support करता है.',
        bodyEn: 'Mercury supports knowledge, speech, money, and strategic intelligence through 2nd and 5th lordship.',
      },
      {
        titleHi: 'लग्नेश भी 6th lord है',
        titleEn: 'The ascendant lord also owns the 6th',
        bodyHi: 'इसलिए comfort-loving nature के साथ work, health, habits और conflict-management को ignore नहीं किया जा सकता.',
        bodyEn: 'Even a pleasure-seeking life must respect routines, health, and practical problem-solving here.',
      },
    ],
  },
  {
    ...lagnaMeta(2),
    accent: 'cyan',
    hookHi: 'मिथुन लग्न का chart mind, speech, flexibility और skill-game का chart है.',
    hookEn: 'Mithuna lagna is a skill chart - quick mind, shifting context, intelligence shown through movement.',
    lagneshFocusHi: 'लग्नेश बुध 1st और 4th own करके mind को identity और inner life दोनों से जोड़ता है.',
    lagneshFocusEn: 'Mercury ruling both the 1st and 4th ties selfhood to thought, learning, and inner processing.',
    yogakarakaHi: 'इस लग्न में कोई single, undisputed yogakaraka नहीं बनता.',
    yogakarakaEn: 'There is no single undisputed yogakaraka here by strict one-planet ownership.',
    specialNotes: [
      {
        titleHi: 'गुरु पर caution',
        titleEn: 'Jupiter needs caution here',
        bodyHi: 'गुरु 7th और 10th own करता है; classical ownership-first reading में यह always simple benefic नहीं माना जाता.',
        bodyEn: 'Jupiter rules the 7th and 10th here, so it should not be treated as automatically benefic in an ownership-only reading.',
      },
      {
        titleHi: 'शनि 9th भी own करता है',
        titleEn: 'Saturn has a delayed dharma tone',
        bodyHi: 'शनि 8th/9th ownership के कारण wisdom को delay, responsibility या deep life-lessons के रास्ते ला सकता है.',
        bodyEn: 'Saturn’s 8th/9th ownership can bring mature fortune, but often through pressure, patience, and deep restructuring.',
      },
    ],
  },
  {
    ...lagnaMeta(3),
    accent: 'slate',
    hookHi: 'कर्क लग्न का empty chart emotionally sensitive होते हुए भी powerful rise का promise रखता है.',
    hookEn: 'Karka lagna looks soft on the surface, but the base chart can be quietly powerful and status-bearing.',
    lagneshFocusHi: 'लग्नेश चंद्र native को responsive, protective और mood-led बनाता है.',
    lagneshFocusEn: 'The Moon as ascendant lord makes the chart responsive, protective, and strongly shaped by emotional climate.',
    yogakarakaHi: 'मंगल 5th और 10th own करके clear yogakaraka बनता है.',
    yogakarakaEn: 'Mars is the clear yogakaraka because it rules both the 5th and the 10th.',
    specialNotes: [
      {
        titleHi: 'गुरु helpful लेकिन mixed',
        titleEn: 'Jupiter helps, but with a service tint',
        bodyHi: '9th lordship strong blessing है, लेकिन 6th ownership struggle, service, debts or problem-solving को भी जोड़ती है.',
        bodyEn: 'Jupiter carries fortune here, but not without service, duty, or friction from the 6th.',
      },
      {
        titleHi: 'शुक्र comfort vs desire',
        titleEn: 'Venus can sweeten and distract',
        bodyHi: '4th/11th शुक्र comfort, networks और pleasures बढ़ा सकता है, पर over-desire भी create कर सकता है.',
        bodyEn: 'Venus can give comfort and circles, but also inflate desire and dependency on approval.',
      },
    ],
  },
  {
    ...lagnaMeta(4),
    accent: 'amber',
    hookHi: 'सिंह लग्न का chart naturally royal, visible और purpose-driven होता है.',
    hookEn: 'Simha Lagna has a throne-like chart skeleton: visible identity, strong purpose, and a need to lead with dignity.',
    lagneshFocusHi: 'लग्नेश सूर्य identity को center-stage पर रखता है; native को notice होना ही पड़ता है.',
    lagneshFocusEn: 'The Sun as ascendant lord puts identity on stage; this chart wants visibility, clarity, and self-command.',
    yogakarakaHi: 'मंगल 4th और 9th own करके clear yogakaraka बनता है.',
    yogakarakaEn: 'Mars is the clear yogakaraka here because it rules the 4th and the 9th.',
    specialNotes: [
      {
        titleHi: 'गुरु pure नहीं, deep helper है',
        titleEn: 'Jupiter helps through depth',
        bodyHi: '5th ownership strong है, पर 8th भी साथ होने से learning कभी simple नहीं रहती; it transforms first, then rewards.',
        bodyEn: 'Jupiter supports intelligence and children themes, but often through deeper transformation rather than easy comfort.',
      },
      {
        titleHi: '12th चंद्र',
        titleEn: 'Moon adds a private inner life',
        bodyHi: 'चंद्र 12th lord होकर inner withdrawal, rest-needs और emotional privacy बढ़ा सकता है.',
        bodyEn: 'The Moon’s 12th lordship can make the emotional world more private, dreamy, or retreat-oriented.',
      },
    ],
  },
  {
    ...lagnaMeta(5),
    accent: 'teal',
    hookHi: 'कन्या लग्न का chart analysis, correction और refinement का chart है.',
    hookEn: 'Kanya Lagna is built for refinement: analysis, correction, method, and life through careful craft.',
    lagneshFocusHi: 'लग्नेश बुध 1st और 10th own करके self और karma को directly जोड़ता है.',
    lagneshFocusEn: 'Mercury ruling the 1st and 10th ties identity directly to work, systems, skill, and public usefulness.',
    yogakarakaHi: 'इस लग्न में कोई single clear yogakaraka नहीं, लेकिन शुक्र बहुत strong helper है.',
    yogakarakaEn: 'There is no single clear yogakaraka here, but Venus is often the strongest helper.',
    specialNotes: [
      {
        titleHi: 'शुक्र is the best helper',
        titleEn: 'Venus is the key grace planet',
        bodyHi: '9th ownership शुक्र को strong dharmic support देता है, even though 2nd lordship adds money and maraka tint.',
        bodyEn: 'Venus gains major strength from the 9th, even though the 2nd house adds finance and maraka colouring.',
      },
      {
        titleHi: 'गुरु पर classical caution',
        titleEn: 'Jupiter needs ownership caution',
        bodyHi: 'गुरु 4th/7th own करके simple benefic नहीं माना जाता; especially relationship and comfort themes need context.',
        bodyEn: 'Jupiter rules the 4th and 7th here, so it should not be treated as automatically auspicious in an ownership-only reading.',
      },
    ],
  },
  {
    ...lagnaMeta(6),
    accent: 'violet',
    hookHi: 'तुला लग्न का base chart balance, design, diplomacy और social intelligence का chart है.',
    hookEn: 'Tula Lagna works through balance, aesthetics, negotiation, and the art of keeping systems in proportion.',
    lagneshFocusHi: 'लग्नेश शुक्र 1st और 8th own करके outer grace के पीछे deep transformation भी रखता है.',
    lagneshFocusEn: 'Venus ruling the 1st and 8th gives style and diplomacy, but also hidden transformation and intensity.',
    yogakarakaHi: 'शनि 4th और 5th own करके clear yogakaraka बनता है.',
    yogakarakaEn: 'Saturn is the clear yogakaraka because it rules both the 4th and the 5th.',
    specialNotes: [
      {
        titleHi: 'शनि यहाँ blessing बनता है',
        titleEn: 'Saturn becomes a blessing here',
        bodyHi: 'तुला लग्न में शनि fear planet नहीं, structure-giving rise planet बन सकता है.',
        bodyEn: 'For Libra ascendant, Saturn is not merely restrictive; it becomes one of the clearest support planets.',
      },
      {
        titleHi: 'लग्नेश का 8th ownership',
        titleEn: 'The ascendant lord also owns the 8th',
        bodyHi: 'इसलिए beauty और diplomacy के पीछे deep psychological change और hidden karmic churn भी रहता है.',
        bodyEn: 'Venus softens the chart, but 8th lordship means there is always a deeper undercurrent beneath the surface polish.',
      },
    ],
  },
  {
    ...lagnaMeta(7),
    accent: 'rose',
    hookHi: 'वृश्चिक लग्न का chart depth, secrecy, endurance और inner power का chart है.',
    hookEn: 'Vrishchika Lagna is built for depth, endurance, strategy, and life through intensity rather than surface comfort.',
    lagneshFocusHi: 'लग्नेश मंगल 1st और 6th own करके self को fighter mode देता है.',
    lagneshFocusEn: 'Mars ruling the 1st and 6th gives a combative, survival-driven, and highly resilient pattern.',
    yogakarakaHi: 'इस लग्न में कोई single, textbook yogakaraka नहीं; सूर्य और चंद्र का 10th-9th axis बहुत important है.',
    yogakarakaEn: 'There is no single textbook yogakaraka here, but the 9th-10th axis of Moon and Sun becomes extremely important.',
    specialNotes: [
      {
        titleHi: 'Moon + Sun pair matters',
        titleEn: 'Moon and Sun matter more as a pair',
        bodyHi: '9th और 10th separate होकर भी इस chart के fortune-work backbone को define करते हैं.',
        bodyEn: 'Even without a single yogakaraka, the 9th and 10th lords shape the chart’s main rise potential.',
      },
      {
        titleHi: 'मंगल mixed है',
        titleEn: 'Mars is strong but not simple',
        bodyHi: 'लग्नेश मंगल strength देता है, लेकिन 6th ownership से struggle, rivalry और heat भी जोड़ता है.',
        bodyEn: 'Mars empowers the native, but 6th lordship means its strength often arrives through conflict, competition, or pressure.',
      },
    ],
  },
  {
    ...lagnaMeta(8),
    accent: 'amber',
    hookHi: 'धनु लग्न का chart dharma, expansion, travel और meaning-seeking का chart है.',
    hookEn: 'Dhanu Lagna naturally stretches toward meaning, teaching, movement, and a life that wants a bigger horizon.',
    lagneshFocusHi: 'लग्नेश गुरु 1st और 4th own करके self, inner grounding और wisdom को जोड़ता है.',
    lagneshFocusEn: 'Jupiter ruling the 1st and 4th links identity with wisdom, foundations, and inner moral direction.',
    yogakarakaHi: 'इस लग्न में कोई single clear yogakaraka नहीं; सूर्य, मंगल और गुरु मुख्य support cluster हैं.',
    yogakarakaEn: 'There is no single clear yogakaraka here; Sun, Mars, and Jupiter form the main support cluster.',
    specialNotes: [
      {
        titleHi: 'बुध needs caution',
        titleEn: 'Mercury needs careful reading',
        bodyHi: '7th/10th ownership बुध को important बनाता है, but not automatically benefic in a strict ownership reading.',
        bodyEn: 'Mercury becomes important through the 7th and 10th, but that does not make it automatically auspicious here.',
      },
      {
        titleHi: 'मंगल helpful but expensive',
        titleEn: 'Mars helps, but with 12th colour',
        bodyHi: '5th ownership strong blessing है; 12th ownership action को travel, expense, sacrifice या retreat से जोड़ सकता है.',
        bodyEn: 'Mars helps strongly through the 5th, but the 12th gives its action a foreign, sacrificial, or expenditure-related tint.',
      },
    ],
  },
  {
    ...lagnaMeta(9),
    accent: 'slate',
    hookHi: 'मकर लग्न का chart delay से घबराता नहीं; यह structure, status और long-game का chart है.',
    hookEn: 'Makara Lagna is a long-game chart: disciplined, pragmatic, and willing to build through time rather than impulse.',
    lagneshFocusHi: 'लग्नेश शनि 1st और 2nd own करके self-worth, speech, family-duty और identity को साथ जोड़ता है.',
    lagneshFocusEn: 'Saturn ruling the 1st and 2nd ties identity to duty, resources, speech, and patient self-construction.',
    yogakarakaHi: 'शुक्र 5th और 10th own करके इस लग्न का clear yogakaraka बनता है.',
    yogakarakaEn: 'Venus is the clear yogakaraka here because it rules the 5th and the 10th.',
    specialNotes: [
      {
        titleHi: 'शनि 2nd भी own करता है',
        titleEn: 'Saturn also owns a maraka house',
        bodyHi: '2nd ownership maraka tint देता है, but लग्नेश होने से शनि की role-reading हमेशा nuanced रहती है.',
        bodyEn: 'Saturn owns a maraka house here, but as the ascendant lord it remains a nuanced planet, not a simple killer label.',
      },
      {
        titleHi: 'शुक्र main grace है',
        titleEn: 'Venus is the clearest grace planet',
        bodyHi: 'मकर लग्न में rise, polish, education-quality और recognition अक्सर शुक्र से visibly improve होते हैं.',
        bodyEn: 'Venus is the clearest upliftment factor here, especially for status, quality of karma, and visible refinement.',
      },
    ],
  },
  {
    ...lagnaMeta(10),
    accent: 'cyan',
    hookHi: 'कुम्भ लग्न का chart systems, reform, detachment और future-thinking का chart है.',
    hookEn: 'Kumbha Lagna thinks in systems, networks, and long-range reforms rather than immediate emotional comfort.',
    lagneshFocusHi: 'लग्नेश शनि 1st और 12th own करके identity में detachment, seriousness और inner distance जोड़ता है.',
    lagneshFocusEn: 'Saturn ruling the 1st and 12th gives seriousness, abstraction, detachment, and a private inner burden.',
    yogakarakaHi: 'शुक्र 4th और 9th own करके clear yogakaraka बनता है.',
    yogakarakaEn: 'Venus is the clear yogakaraka here because it rules the 4th and the 9th.',
    specialNotes: [
      {
        titleHi: 'शनि detached tone देता है',
        titleEn: 'Saturn adds distance to identity',
        bodyHi: '12th lordship के कारण native को कभी-कभी inward, distant या emotionally unavailable महसूस किया जा सकता है.',
        bodyEn: 'Because Saturn also rules the 12th, identity can feel withdrawn, private, or emotionally distant at times.',
      },
      {
        titleHi: 'गुरु यहाँ simple benefic नहीं',
        titleEn: 'Jupiter is not simple here',
        bodyHi: '2nd/11th ownership material growth दे सकता है, but strict ownership reading में it also fuels greed, pressure or desire-expansion.',
        bodyEn: 'Jupiter can give gains, but 2nd/11th lordship also makes it materially hungry and not automatically auspicious here.',
      },
    ],
  },
  {
    ...lagnaMeta(11),
    accent: 'violet',
    hookHi: 'मीन लग्न का chart sensitivity, surrender, faith और inner imagination का chart है.',
    hookEn: 'Meena Lagna lives through intuition, surrender, and imagination; its chart seeks meaning more than control.',
    lagneshFocusHi: 'लग्नेश गुरु 1st और 10th own करके self और karma को dharmic center देता है.',
    lagneshFocusEn: 'Jupiter ruling the 1st and 10th gives the chart a dharmic center and a meaning-linked public path.',
    yogakarakaHi: 'इस लग्न में कोई single clear yogakaraka नहीं; गुरु, चंद्र और मंगल strongest support cluster बनाते हैं.',
    yogakarakaEn: 'There is no single clear yogakaraka here; Jupiter, Moon, and Mars form the strongest support cluster.',
    specialNotes: [
      {
        titleHi: 'बुध पर strong caution',
        titleEn: 'Mercury deserves caution here',
        bodyHi: '4th/7th ownership बुध को important बनाती है, but strict ownership-first reading में यह automatically benefic नहीं माना जाता.',
        bodyEn: 'Mercury becomes important through the 4th and 7th, but it should not be assumed benefic in a strict ownership-only framework.',
      },
      {
        titleHi: 'मंगल blessed but sharp',
        titleEn: 'Mars helps, but with edge',
        bodyHi: '9th ownership मंगल को strong support देता है, though 2nd lordship maraka tint भी जोड़ती है.',
        bodyEn: 'Mars gains major support from the 9th, but the 2nd house adds a maraka edge and a sharper tone.',
      },
    ],
  },
];

export const LAGNA_BASELINE_TABS = LAGNA_BASELINE_PAGES.map((page) => ({
  id: page.topicId,
  label: page.lagnaHi,
}));

export function getLagnaBaselinePage(topicId) {
  return LAGNA_BASELINE_PAGES.find((page) => page.topicId === topicId) ?? null;
}

export function getLagnaBaselinePageByIndex(lagnaIndex) {
  return LAGNA_BASELINE_PAGES.find((page) => page.lagnaIndex === lagnaIndex) ?? null;
}
